import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { BrandService } from './brand.service';

@Injectable({ providedIn: 'root' })
export class BrandMetaService {
  apply(): void {
    const cfg = this.brand.config;
    if (!cfg) return; // ✅ prevents white screen when config isn't ready

    const baseTitle = 'App';
    this.title.setTitle(`${baseTitle}${cfg.titleSuffix ?? ''}`);

    if (cfg.metaDescription) {
      this.meta.updateTag({ name: 'description', content: cfg.metaDescription });
    }

    if (cfg.ogImagePath) {
      this.meta.updateTag({ property: 'og:image', content: cfg.ogImagePath });
    }

    // favicon swap
    if (cfg.faviconPath) {
      const link: HTMLLinkElement =
        document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = cfg.faviconPath;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }

  constructor(private title: Title, private meta: Meta, private brand: BrandService) {}
}
